import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const getOrderList = (states, donationID) => {
  return api.post(`${ApiEndpointConstants.GET_ORDER_LIST}`, {
    states,
    donationID,
  });
};
